import Button from '@berlitz/button'
import Spacer from '@berlitz/spacer'
import LockUnlock1 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/LockUnlock1'
import Tick from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check'
import AwardTrophyStart1 from '@berlitz/streamline-icons/lib/bold/22-Social-Medias-Rewards-Rating/08-Rewards-Awards/AwardTrophyStar1'
import LearningPath from '@classes/LearningPath'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Card, CardContent, Icon, IconCircle, Title } from '@components/LPCard/Common'
import { LP_STATUS } from '@utils/constants/learningPath'
import Router from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { SubContainer, SubDescription, SubTitle, UnlimitedLCSDesc } from './style'

export const Completed: React.FC<{
  Path: LearningPath
  allBooked?: boolean
  Unit: PortalLearningPathUnit
  MainPath?: LearningPath
}> = ({ Path, Unit, MainPath }) => (
  <Card type="speakingPanel" completed withConfetti active>
    <CardContent>
      <Icon color="white">
        <IconCircle color="white" opacity="0.27" />
        {Unit?.UnlimitedLCS ? (
          <LockUnlock1 />
        ) : Path.LPLCSStatus === LP_STATUS.COMPLETE ? (
          <AwardTrophyStart1 />
        ) : (
          <Tick />
        )}
      </Icon>

      <Spacer size="md" />

      <Title>
        {Unit?.UnlimitedLCS ? (
          <FormattedMessage id="Live coaching session" defaultMessage="Live coaching session" />
        ) : (
          <FormattedMessage id="Congratulations!" defaultMessage="Congratulations!" />
        )}
      </Title>

      <Spacer size="sm" />

      <SubContainer shadowed>
        <Spacer size="sm" />

        <SubTitle color="blue100">
          {Unit?.UnlimitedLCS ? (
            <FormattedMessage id="Practice makes perfect!" defaultMessage="Practice makes perfect!" />
          ) : Path.LPLCSStatus === LP_STATUS.COMPLETE ? (
            <>
              {MainPath?.IsFoundation ? (
                <FormattedMessage id="You’ve completed all live coaching sessions in your core course." />
              ) : MainPath?.IsElective ? (
                <FormattedMessage id="You’ve completed all live coaching sessions in your elective course." />
              ) : (
                <FormattedMessage id="You've completed all Live Coaching Sessions" />
              )}
            </>
          ) : (
            <FormattedMessage
              id="completed-xx-lessons"
              defaultMessage="You've completed {count} Live Coaching Sessions"
              values={{ count: Path.CompletedOrOngoingLCS.length }}
            />
          )}
        </SubTitle>

        {Unit?.UnlimitedLCS ? (
          <>
            <Spacer size="xxs" />
            <Spacer size="xxxs" />
          </>
        ) : (
          <Spacer size="sm" />
        )}

        <SubDescription color="charcoal">
          <div>
            {Unit?.UnlimitedLCS ? (
              <UnlimitedLCSDesc>
                <FormattedMessage id="You now have access to unlimited coaching sessions." />
              </UnlimitedLCSDesc>
            ) : Path.LPLCSStatus === LP_STATUS.COMPLETE ? (
              MainPath?.IsFoundation ? (
                <FormattedMessage id="Make sure you have also completed all activities in your Elective." />
              ) : MainPath?.IsElective ? (
                <FormattedMessage id="Make sure you have also completed all activities in your Core." />
              ) : (
                <FormattedMessage id="Interested in another course?" />
              )
            ) : (
              <FormattedMessage id="Practice makes perfect" />
            )}
          </div>
        </SubDescription>

        <Spacer size="sm" />

        {Path.LPLCSStatus === LP_STATUS.COMPLETE ? (
          !MainPath?.IsElective &&
          !MainPath?.IsFoundation && (
            <>
              <Button
                onClick={() => {
                  Router.push(`/support/contact-us/?id=my-lessons&cat=Add%20on%20products`)
                }}
              >
                <FormattedMessage id="Contact us" />
              </Button>
            </>
          )
        ) : (
          <>
            <Button
              onClick={() => {
                Router.push(
                  `/scheduling/single-lesson?programid=${Path?.Program?.ProgramId}&unitId=0000&LPId=${Path.Id}`
                )
              }}
            >
              {Unit?.UnlimitedLCS ? (
                <FormattedMessage id="Book a session" />
              ) : (
                <FormattedMessage id="Book another session" />
              )}
            </Button>
          </>
        )}
        <Spacer size="sm" />
      </SubContainer>
    </CardContent>
  </Card>
)

export default Completed
